<template>
  <div ref="mainDiv" class="main-div" id="mainDiv">
    <div class="main-toolbar"  v-if="isShowToolbar">
      <div class="but-list">
        <div v-for="(item,index) in configure.toolbar" class="single-but-list">
          <div class="th-button" @click="item.handler()">
            <i :class="item.iconCls" />
            <span>{{ item.text }}</span>
          </div>
        </div>
      </div>
      <div class="fun-list">
        <el-dropdown class="table-fun-list" trigger="click" @command="moreFunClick">
          <div class="user-container">
            <div class="th-button">
              <i class="wk wk-list3"></i>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown" class="el-dropdown-unarrow">
            <el-dropdown-item command="refresh"><div class="table-fun-list-item"><xr-icon type="refresh1" @click="getData()"/>刷新</div></el-dropdown-item>
            <el-dropdown-item command="export"><div class="table-fun-list-item"><xr-icon type="export"/>导出</div></el-dropdown-item>
            <el-dropdown-item command="resetSearch"><div class="table-fun-list-item"><xr-icon type="refresh"/>清空查询条件</div></el-dropdown-item>
            <el-dropdown-item command="tableSetting"><div class="table-fun-list-item"><xr-icon type="table"/>表格列配置</div></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="main-table">
      <el-table
        v-loading="loading"
        v-if="!configure.isTreeTable"
        ref="normalTable"
        :data="configure.tableData"
        border
        :row-key="(row) => {return row[configure.idField]}"
        :row-class-name="tableRowClassName"
        @row-click="handleClickTableRow"
        :height="tableHeight">
        <el-table-column v-for="(item,index) in configure.columns" :key="item.field" :prop="item.field" :width="item.width" :show-overflow-tooltip='true'>
          <template slot="header" slot-scope="scope">
            <!-- checkbox列 -->
            <div class="header-div" v-if="item.field == 'ck'">
              <div class="header-title">
                <a class="corner-marker" v-show="multipleSelection.length > 1">{{multipleSelection.length}}</a>
                <el-checkbox v-model="allCheck" @click.native.stop="handleAllSelection($event)" />
              </div>
            </div>
            <!-- radio 单选列 -->
            <div class="header-div" v-else-if="item.field == 'radio'">
              <div class="header-title"></div>
            </div>
            <!-- 序号 -->
            <div class="header-div" v-else-if="item.field == 'sn'">
              <div class="header-title">序号</div>
            </div>
            <!-- 正常列 -->
            <div class="header-div" v-else>
              <div class="header-title">{{item.title}}</div>
            </div>
          </template>
          <template #default="scope">
            <div class="table-checkbox" v-if="item.field == 'ck'" style="text-align: center;">
              <el-checkbox v-model="scope.row.checked" @click.native.stop="handleSelection($event,scope.row)"></el-checkbox>
            </div>
            <div v-else-if="item.field == 'radio'" style="text-align: center;">
              <el-radio class="radio" v-model="radio_value" :label="scope.row[configure.idField]">&nbsp;</el-radio>
            </div>
            <div v-else-if="item.field == 'sn'" style="text-align: center;">{{scope.row.index}}</div>
            <div v-else-if="item.cellType == 'click'" class="click-cell" v-html="cellView(item,scope.row)" @click="cellClick(item,scope.row)" :style="{textAlign: item.align?item.align:'left'}"></div>
            <div v-else-if="item.cellType == 'operate'" class="operate-div">
              <a v-for="operate in item.operateList" v-if="!operate.display||operate.display(scope.row)" @click="operate.handler(scope.row)">{{operate.text}}</a>
            </div>
            <div v-else v-html="cellView(item,scope.row)" :style="{textAlign: item.align?item.align:'left'}"></div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import elementResizeDetectorMaker from "element-resize-detector";
  import  XrHeaderSearch from '../XrHeaderSearch/index'

  export default {
    // table 表格
    name: 'XrTable',
    props: {
      configure: {
        type: Object,
        default: () =>({
          isShowToolbar: {
            type: Boolean,
            default:() => true
          },
        })
      }
    },
    inject: {
      clickTableRow: {
        default: 'clickTableRow'
      },
      viewRowInfo: {
        default: 'viewRowInfo'
      }
    },
    provide(){
      return{
        refreshRowData:this.refreshRowData,
        handleClickTableRow:this.handleClickTableRow,
      }
    },
    data() {
      return {
        loading: false,
        isShowToolbar: true,                  //是否显示工具栏
        editable: {},                         //可编辑的map
        allCheck: false,
        inputValue: '',
        tableHeight: 260,
        query: {},
        multipleSelection: [],                //批量选中的值
        multipleSelectionItem:[],             //批量选中的对像
        tableDivHeight: '400px',
        tableData: [],
        radio_value: '',
        radio_row: {},
      }
    },
    components: {
      XrHeaderSearch
    },
    mounted() {
      const that = this
      const erd = elementResizeDetectorMaker();
      erd.listenTo(document.getElementById("mainDiv"), element => {
        that.$nextTick(() => {
          setTimeout(function(){
            if(!that.configure.tableHeight){
              //监听到事件后执行的业务逻辑
              let heightStyle = that.$refs.mainDiv.offsetHeight
              if(!!that.configure.pagination){  //如果有分页
                that.tableHeight = heightStyle - 73
              }else{  //如果没有分页
                that.tableHeight = heightStyle - 40
              }

            }
          },100)
        });
      });

      this.$nextTick(()=>{ // 页面渲染完成后的回调
        setTimeout(function(){
          if(!that.configure.tableHeight){
            let heightStyle = that.$refs.mainDiv.offsetHeight
            if(!!that.configure.pagination){  //如果有分页
              that.tableHeight = heightStyle - 73
            }else{  //如果没有分页
              that.tableHeight = heightStyle - 40
            }
          }
        },100);
      })
    },
    created() {
      this.init();
      if(!this.configure.defaultNoLoadData){  //默认不加载数据为false或空的时候，加载数据
        this.getData();     //获取列表数据
      }
    },
    methods: {
      //初始化
      init() {
        if (this.configure.tableHeight){
          this.tableHeight = this.configure.tableHeight
        }

        if(this.configure.isShowToolbar != null && this.configure.isShowToolbar != undefined){
          this.isShowToolbar = this.configure.isShowToolbar;
        }

      },
      //获取数据
      getData() {
        this.configure.tableData.forEach(element => {
          element['checked'] = false
          if(element.children){
            this.setChildToBeSelect(element.children,false);
          }
        });
        //选中第一行
        if(this.configure.isSelectFirst && this.configure.tableData  != null){
          this.handleClickTableRow(this.configure.tableData[0],'first');
        }
      },
      cellView(item,row){  //单元格显示
        if(item.formatter){
          return item.formatter(row[item.field])
        }else if(item.condition&&item.condition.searchType == 'select'){
          let viewValue = '';
          for(let i = 0 ; i < item.condition.selectList.length ; i ++){
            if(item.condition.selectList[i].value == row[item.field]){
              viewValue = item.condition.selectList[i].label;
            }
          }
          return viewValue;
        }else{
          return row[item.field]
        }
      },
      refreshSelectList(){
        let multipleSelection = [];
        let multipleSelectionItem = []
        this.configure.tableData.forEach(item => {
          if(item.children){
            item.children.forEach(child => {
              if(child.checked){
                multipleSelection.push(child.id);
               multipleSelectionItem.push(child);
              }
            })
          }else {
            if(item.checked){
              multipleSelection.push(item.id);
              multipleSelectionItem.push(item);
            }
          }

        });
        this.multipleSelection = multipleSelection;
				this.multipleSelectionItem = multipleSelectionItem;
        //如果全选了，设置全选
        if(this.multipleSelection.length == this.configure.tableData.length){
          this.allCheck = true;
        }else {
          this.allCheck = false;
        }

      },
      searchClick(value,columName) {
        this.query[columName] = value;
        this.getData();
      },
      // 分页导航
      handlePageChange(val) {
        this.query.pageIndex = val
        this.getData();
      },
      //把每一行的索引放进row
      tableRowClassName ({row, rowIndex}) {
        row.index = rowIndex + 1;
        if(row.returnnote != '' && row.returnnote != null && row.returnnote != 'undefined'){
        	 return 'warning-row';
        }
      },
      //点击当前行【关闭当前行】
      handleClickTableRow(row,col,event){
        if(!col){ //如果点击其他地方
          return false;
        }

        //先将所有的选中取消掉
        this.configure.tableData.forEach(item => {
          item.checked = false
        })
        if(row){
          //将当前行选中
          row.checked = true;
          this.radio_value = row[this.configure.idField];
          this.radio_row = row;
          this.configure.tableData.splice(1,0);
          this.refreshSelectList();
          //单行事件【调用父方法】
          if(this.configure.onClickRow){
            this.configure.onClickRow(row);
          }
        }


      },
      //点击checkbox【正常表格】
      handleSelection(e,row){
        //防止冒泡
        if (e.target.tagName === 'SPAN') return;

        //1、若有子集先让子选中
        if (row.children) {
          this.setChildToBeSelect(row.children, !row.checked);

          //展开
          row.isExpand = true;
        }

        if(row.checked){
          row.checked = false;
        }else {
          row.checked = true;
        }
        this.configure.tableData.splice(1,0);
        this.refreshSelectList();
      },
      //正选/反选 子的checkbox
      setChildToBeSelect(arr, key){
        arr.forEach((v, i) => {
          v.checked = key;
        })
      },
      //全选【正常表格】
      handleAllSelection(e){
        //防止冒泡
        if (e.target.tagName === 'SPAN') return;
        //如果不是所有都选中，就全选，否则反选
        if(this.allCheck){   //全选了，设置反选
          this.configure.tableData.forEach(item => {
            item.checked = false
            if(item.children){
              this.setChildToBeSelect(item.children,false);
            }
          })
        }else {
          this.configure.tableData.forEach(item => {
            item.checked = true
            if(item.children){
              this.setChildToBeSelect(item.children,true);
            }
          })
        }
        this.configure.tableData.splice(1,0);
        this.refreshSelectList();
      },
      //关闭快捷查询
      closeQuickSearch(){
        this.configure.isShowSearch = false;
      },
      //重置搜索框
      closeResetSearch(){
        this.configure.columns.forEach(item => {
          if(item.condition && item.condition.searchName){
            this.query[item.condition.searchName] = ''
            item.condition.value = ''
          }
        });
      },
      //右上角的点击事件
      moreFunClick(command){
        if (command == 'refresh') {  //如果是 【刷新】
          location.reload();
        } else if (command == 'export') {
          alert('建设中~');
        } else if(command == 'quickSearch'){
          if(this.configure.isShowSearch){
            this.configure.isShowSearch = false;
          }else {
            this.configure.isShowSearch = true;
          }
        }else if(command == 'resetSearch'){
          this.closeResetSearch();
        }else if(command == 'tableSetting'){
          alert('建设中~');
        }
      },
      submit(searchName,value){
        this.query[searchName] = value;
        this.getData();  //重新加载表格
      },
      rowData(row) {
        return row;
      },
      //修改某一列的值
      editRowColumnData(id, columnName, value){
        if(!this.configure.idField || !columnName){
          return false;
        }
        let tableData = this.configure.tableData;
        let index = -1;
        for(let i = 0; i < tableData.length; i ++){
          if(tableData[i][this.configure.idField] == id){
            index = i;
          }
        }
        if(index < 0){
          return false;
        }
        this.configure.tableData[index][columnName] = value;
      },
      refreshRowData(row){
        //刷新数据
        row.isEdit = true;
        if(this.$refs.normalTable){
          this.$set(this.$refs.normalTable.tableData,row.index - 1,row);
        }else if(this.$refs.multipleTable){
          this.$set(this.$refs.multipleTable.tableData,row.index - 1,row);
        }
      },
      //合并列
      arraySpanMethod({row, column, rowIndex, columnIndex}){
        if (row.columnType == 'parent') { // 在这里多加一个行的判断就行
          // 合并第二行
          if (columnIndex === this.configure.multiple.mergeStartIndex) {
            return [this.configure.multiple.mergeStartIndex, this.configure.multiple.mergeEndIndex]
          } else if (columnIndex > this.configure.multiple.mergeStartIndex) {
            return [0, 0]
          }
        }
      },
      //展开列
      expandChildren(row){
        if(row.isExpand){
          this.$refs.multipleTable.toggleRowExpansion(row,false);  //就是树形表格控制折叠和展开的语句  true是展开
          row.isExpand = false;
        }else {
          this.$refs.multipleTable.toggleRowExpansion(row,true);  //就是树形表格控制折叠和展开的语句  true是展开
          row.isExpand = true;
        }
        // this.$refs.TreeName.store.nodesMap[item.id].expanded =true/false; //就是控制树形控件折叠和展开的关键语句
      },
      cellClick(item,row){
        item.handler(row);
      }

    }
  }
</script>

<style lang="scss" scoped>

  .main-div{
    height: 100%;
    width: calc(100%);

  }



  .main-table .pagination{text-align: center;}

  .el-pagination .el-pagination__total{color: rgba(0,0,0,.45)}

  .el-table .cell{
    height: 100%;
  }

  .el-select{
    width: 100% !important;
  }

  .operate-div{text-align: center;}
  .operate-div a{text-decoration: none;color: #007aff;height: auto;width: 100%;margin: 0 10px;}


</style>



// WEBPACK FOOTER //
// src/components/XrTable/dataTable.vue